module.exports = "<div class=\"wrapper\">\r\n    <div id=\"calculator-container\">\r\n        <div class=\"limit-message\">\r\n            <h2>You have reached the maximum calculation limit – please try again in 24 hours</h2>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/limit/limit.component.html
// module id = ./src/app/components/limit/limit.component.html
// module chunks = main